"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ethUtil = require('ethereumjs-util');

var cryptoJS = {
  AES: require('crypto-js/aes'),
  PBKDF2: require('crypto-js/pbkdf2'),
  enc: {
    Utf8: require('crypto-js/enc-utf8')
  },
  lib: {
    WordArray: require('crypto-js/lib-typedarrays')
  }
};

var Engine = require('./engine').zeroc;

var _require = require('../storage'),
    sessionStorage = _require.sessionStorage;

var util = require('../util');

var error = require('../constant/error');

var SoftWallet =
/**
 * @constructor
 * @param {*} net - Network id
 * @param {*} accOpts - accOpts = {
 *   address: ...
 *   privateKey: ...
 *   getPassphrase: ...
 * }
 */
function SoftWallet(net) {
  var _this = this;

  _classCallCheck(this, SoftWallet);

  _defineProperty(this, "opts", function () {
    return {
      dataHandler: function dataHandler() {
        /* Turn off default logs */
      },
      errorHandler: function errorHandler() {
        /* Turn off dÎefault logs */
      },
      getAccounts: function getAccounts(callback) {
        var accounts = _this.getAddress();

        return callback(null, accounts);
      },
      approveTransaction: function approveTransaction(txParams, callback) {
        return _this.approveTransaction(txParams, function (er, approved) {
          if (er || !approved) return callback(error.USER_DENIED_TX, false);
          return callback(null, true);
        });
      },
      signTransaction: function signTransaction(txParams, callback) {
        txParams.chainId = _this.network;
        return _this.getPassphrase(function (er, passphrase) {
          if (er || !passphrase) return callback(error.CANNOT_UNLOCK_ACCOUNT, null);

          var priv = _this.unlockAccount(passphrase);

          if (!priv) return callback(error.CANNOT_UNLOCK_ACCOUNT, null);
          var signedTx = util.signRawTx(txParams, priv);
          return callback(null, signedTx);
        });
      },
      killSession: function killSession() {
        return sessionStorage.remove();
      }
    };
  });

  _defineProperty(this, "init", function (accOpts, callback) {
    accOpts = accOpts || {};
    var engine = new Engine(_this.network, _this.opts());
    return _this.setAccount(accOpts, function (er, re) {
      if (er || !re) return callback(error.CANNOT_SET_ACCOUNT, null);
      return callback(null, engine.web3);
    });
  });

  _defineProperty(this, "setAccount", function (accOpts, callback) {
    var address = accOpts.address,
        privateKey = accOpts.privateKey,
        getPassphrase = accOpts.getPassphrase,
        approveTransaction = accOpts.approveTransaction;
    if (!getPassphrase || typeof getPassphrase !== 'function') return callback('getPassphrase must be a function', null);
    if (!approveTransaction || typeof approveTransaction !== 'function') return callback('approveTransaction must be a function', null);
    _this.getPassphrase = getPassphrase;
    _this.approveTransaction = approveTransaction;
    if (!address || !privateKey) return callback(null, true); // In case, user want to resume

    address = address.toLowerCase();
    privateKey = privateKey.toLowerCase();
    if (!_this.validatePrivateKey(address, privateKey)) return callback('Invalid address or private key', null);
    return _this.getPassphrase(function (er, passphrase) {
      if (er) return callback(er, null);
      if (!passphrase) return callback(er, 'User denied unlocking account');
      passphrase = passphrase.toString();
      var salt = cryptoJS.lib.WordArray.random(128 / 8);

      var password = _this.constructPassword(passphrase, salt);

      if (!password) return callback('Cannot set up password', null);
      var encryptedPriv = cryptoJS.AES.encrypt(privateKey, password).toString();
      var acc = {
        ADDRESS: address,
        ENCRYPTED_PRIVATEKEY: encryptedPriv,
        SALT: salt
      };
      sessionStorage.set(acc);
      return callback(null, acc);
    });
  });

  _defineProperty(this, "validatePrivateKey", function (addr, priv) {
    try {
      if (!addr || !priv) return false;
      priv = new Buffer(priv, 'hex');
      var valid = ethUtil.isValidPrivate(priv);

      var _addr = '0x' + ethUtil.privateToAddress(priv).toString('hex');

      valid = valid && _addr === addr;
      return valid;
    } catch (er) {
      if (er) return false;
    }
  });

  _defineProperty(this, "constructPassword", function (passphrase, salt) {
    if (!passphrase || !salt) return null;
    var password = cryptoJS.PBKDF2(passphrase, salt, {
      keySize: 512 / 32,
      iterations: 1000
    });
    return password.toString();
  });

  _defineProperty(this, "unlockAccount", function (passphrase) {
    try {
      var password = _this.constructPassword(passphrase, _this.getSalt());

      var enpriv = _this.getEncryptedPrivateKey();

      if (!password || !enpriv) return null;
      var priv = cryptoJS.AES.decrypt(enpriv, password);
      if (!priv) return null;
      priv = priv.toString(cryptoJS.enc.Utf8);
      return priv;
    } catch (er) {
      return console.error('Cannot unlock account');
    } // Try catch unexpected Error

  });

  _defineProperty(this, "getAddress", function () {
    var acc = sessionStorage.get();
    if (!acc || _typeof(acc) !== 'object') return [];
    return [acc.ADDRESS];
  });

  _defineProperty(this, "getEncryptedPrivateKey", function () {
    // the encrypted form of private key
    var acc = sessionStorage.get();
    if (!acc || _typeof(acc) !== 'object') return null;
    return acc.ENCRYPTED_PRIVATEKEY;
  });

  _defineProperty(this, "getSalt", function () {
    var acc = sessionStorage.get();
    if (!acc || _typeof(acc) !== 'object') return null;
    return acc.SALT;
  });

  this.network = util.getNetworkId(net, 'number');
}
/**
 * @func opts
 * Define optional functions for engine
 */
;

module.exports = SoftWallet;